(function () {
  var THRESHOLD = 10000;

  function updateMeter() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var total = cart.total_price || 0;
        var el = document.getElementById('CartDrawer-CartItems');
        if (!el) return;

        var m = el.querySelector('.nyne-meter');
        if (!m) {
          m = document.createElement('div');
          m.className = 'nyne-meter';
          el.insertBefore(m, el.firstChild);
        }

        if (total <= 0) {
          m.style.display = 'none';
          return;
        }

        var pct = Math.min(100, Math.round(total * 100 / THRESHOLD));
        var achieved = total >= THRESHOLD;
        var rem = (Math.max(0, THRESHOLD - total) / 100).toFixed(2);
        var color = achieved ? '#2a9d5c' : '#4facfe';
        var msgCss = 'font-size:13px;margin:0 0 10px;text-align:center;line-height:1.4;' + (achieved ? 'color:#2a9d5c;font-weight:600;' : '');
        var msgHtml = achieved
          ? 'You&#8217;ve unlocked free shipping!'
          : 'Spend <strong>$' + rem + '</strong> more for free shipping';

        m.style.cssText = 'display:block;padding:14px 0 16px;border-bottom:1px solid rgba(0,0,0,0.12);margin-bottom:8px;';
        m.innerHTML =
          '<p style="' + msgCss + '">' + msgHtml + '</p>' +
          '<div style="display:block;height:5px;background:rgba(0,0,0,0.1);border-radius:100px;overflow:hidden;">' +
          '<div style="display:block;height:100%;border-radius:100px;background:' + color + ';width:' + pct + '%;"></div>' +
          '</div>';
      })
      .catch(function () {});
  }

  document.addEventListener('DOMContentLoaded', function () {
    var CartDrawerCtor = customElements.get('cart-drawer');
    if (CartDrawerCtor) {
      var origOpen = CartDrawerCtor.prototype.open;
      CartDrawerCtor.prototype.open = function () {
        origOpen.apply(this, arguments);
        setTimeout(updateMeter, 300);
      };

      var origRender = CartDrawerCtor.prototype.renderContents;
      CartDrawerCtor.prototype.renderContents = function (state) {
        origRender.apply(this, arguments);
        setTimeout(updateMeter, 400);
      };
    }

    var CartDrawerItemsCtor = customElements.get('cart-drawer-items');
    if (CartDrawerItemsCtor) {
      var origOnCartUpdate = CartDrawerItemsCtor.prototype.onCartUpdate;
      if (origOnCartUpdate) {
        CartDrawerItemsCtor.prototype.onCartUpdate = function () {
          var result = origOnCartUpdate.apply(this, arguments);
          if (result && typeof result.then === 'function') {
            result.then(function () { setTimeout(updateMeter, 300); });
          }
          return result;
        };
      }
    }

    setInterval(function () {
      var d = document.querySelector('cart-drawer');
      if (d && d.classList.contains('active')) updateMeter();
    }, 2000);
  });
})();
